import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from './BackButton';

export default function StsLogin() {
  const { t } = useTranslation('sts_login'); // используем namespace sts.json
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login === 'admin' && password === 'P@ssw0rd2025$') {
      localStorage.setItem('sts_auth', 'true');
      navigate('/sts');
    } else {
      setError(t('error'));
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center text-white bg-gradient-to-b from-[#070b15] to-[#0a111f] px-4 overflow-hidden">
      <div className="grid-bg opacity-60" />
      <div className="glow-orb w-[480px] h-[480px] bg-[#0070d2] opacity-20 -top-32 -left-32 [animation:drift-slow_24s_ease-in-out_infinite,glow-pulse_9s_ease-in-out_infinite]" />
      <div className="glow-orb w-[420px] h-[420px] bg-[#00c2ff] opacity-20 bottom-[-140px] right-[-120px] [animation:drift_15s_ease-in-out_infinite_2s,glow-pulse_9s_ease-in-out_infinite_1.5s]" />

      <div className="absolute top-8 left-4 sm:top-10 sm:left-8 z-10">
        <BackButton label={t('back')} to="/" className="mb-0" />
      </div>

      <form
        onSubmit={handleSubmit}
        className="glass-card relative w-full max-w-sm rounded-3xl p-8 animate-fade-in"
      >
        <h2 className="font-display text-xl font-bold text-center text-white mb-6">{t('title')}</h2>

        <input
          type="text"
          placeholder={t('login')}
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 mb-3 text-white placeholder:text-white/40 focus:border-cyan-400/50 focus:outline-none transition"
        />
        <input
          type="password"
          placeholder={t('password')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 mb-3 text-white placeholder:text-white/40 focus:border-cyan-400/50 focus:outline-none transition"
        />
        {error && <p className="text-red-400 text-sm mb-3">{error}</p>}
        <button type="submit" className="font-display btn-primary w-full justify-center">
          {t('submit')}
        </button>
      </form>
    </section>
  );
}
